import _extends from "@babel/runtime/helpers/extends";
/**@jsx jsx */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { wrapperStyles } from './styles';
export var Wrapper = function Wrapper(props) {
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    jsx("div", _extends({
      css: wrapperStyles({
        dimensions: props.dimensions
      })
    }, props), props.children)
  );
};